import requestAction from '../../utils/requestAction'

export const fetchJobs = () =>
  requestAction('JOB_LIST')('jobs', 'GET')

